import { UPDATE_STEP } from './types';

export const updateStep = (data) => async dispatch => {
    try {
        dispatch({ type: UPDATE_STEP, payload: data });
    } catch (errors) {
        // dispatch({ type: SET_ERRORS, payload: { error: "Unable to get current step" }});
    }
};